import React, { useState } from 'react';
import {
  OnboardingContainer,
  HeaderFlag,
  OnboardingInformationContainer,
  OnboardingInformationBox,
  OnboardingHeading,
  Frame1410,
  LocationAgeContainer,
  EditBtn,
} from './headerOnboardingMenuStyle';
import OnboardingScreen from './OnboardingScreen';
import countriesData from './countries.json';
import { getLocalStorage } from '../../utils/function';

export function formatOnboardingLocation({ year, country, state }) {
  return [
    year ? `Year ${year}` : null,
    country || null,
    state && state !== 'NZ' ? state : null,
  ]
    .filter(Boolean)
    .join(', ');
}

const HeaderOnboardingMenu = () => {
  const [showOnboardingPopup, setShowOnboardingPopup] = useState(false);
  const state = getLocalStorage('state');
  const year = getLocalStorage('year');
  const savedCountry = getLocalStorage('country');
  const defaultCountry = savedCountry || Object.keys(countriesData)[0] || 'Australia';
  const [country, setCountry] = useState(defaultCountry);

  const findFlagIcon = (stateCode) => {
    const countryEntries = countriesData[country];
    if (!countryEntries) return 'img/australia.png';
    const match = countryEntries.find((c) => c.state === stateCode);
    return match ? match.flagIcon : countryEntries[0]?.flagIcon || 'img/australia.png';
  };

  const flagIcon = findFlagIcon(state);

  return (
    <>
      {showOnboardingPopup && (
        <OnboardingScreen
          editStateYear={true}
          onClose={() => setShowOnboardingPopup(false)}
        />
      )}
      <OnboardingContainer>
        <HeaderFlag
          src={flagIcon}
          onError={(e) => {
            // img/newzealand.png may not be bundled yet — fall back to an
            // existing flag asset rather than showing a broken image.
            if (e.currentTarget.src.indexOf('australia.png') === -1) {
              e.currentTarget.src = 'img/australia.png';
            }
          }}
        />
        <OnboardingInformationContainer>
          <OnboardingInformationBox>
            <OnboardingHeading>LOCATION</OnboardingHeading>
            <Frame1410>
              <LocationAgeContainer>
                <div>
                  {formatOnboardingLocation({ year, country, state })}
                </div>
              </LocationAgeContainer>
              <EditBtn
                onClick={() => {
                  setShowOnboardingPopup(true);
                }}
              >
                <img src="/img/editSmall.png" />
                <p>Edit</p>
              </EditBtn>
            </Frame1410>
          </OnboardingInformationBox>
        </OnboardingInformationContainer>
      </OnboardingContainer>
    </>
  );
};

export default HeaderOnboardingMenu;
